(function($) {
  $('.video .video_container .video_play').on('click', function () {
    var $videoWidget = $(this).parent('.video_container')
    var videoUrl = $videoWidget.data('video-url')
    $videoWidget.append('<iframe class="video_embedded" src="' + videoUrl + '" allowfullscreen></iframe><div class="video_embedded_close"></div>')
    $('.video_embedded_close').on('click', function (e) {
      e.preventDefault()
      $('.video .video_container .video_embedded, .video .video_container .video_embedded_close, .video .video_container .video_embedded').fadeTo(250, 0, function () {
        $('.video .video_container .video_embedded_close, .video .video_container .video_embedded').remove()
      })
    })
  })
})(jQuery);
